/** global function **/
const FN = {};

/**
 * Checks radiobutton [name] with value [value] in form [frm] (unchecks if [value] is not among values)
 */
FN.checkRadioValue = (frm, name, value) => frm && frm.querySelectorAll(`[name=${name}]`).forEach(item => item.checked = item.value==value);

/**
 * Unchecks the boxes (radiobutton or checkbox) corresponding to the given CSS selector
 */
FN.uncheckInput = selector => document.querySelectorAll(selector).forEach(input => input.checked = false);

/**
 * Formats a number as currency, separating thousands and tens according to locale
 * format.locale (e.g. cs-CZ) - there is a dash, an underscore is being replaced in the code
 * format.currencyCode (e.g. CZK) - replaced by the currency symbol, or by an abbreviation in the given language, if it exists (€, Kč), placed before or after the number according to the locale
 * format.decimals (e.g. 2) - how many decimal places to display
 */
FN.priceFormat = function(price, format) {
    var value = parseFloat(price||0);
    try {
        return value.toLocaleString(format.locale.replace("_","-"), {
            style: "currency",
            currency: format.currencyCode,
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: format.decimals||0,
            maximumFractionDigits: format.decimals||0
        });
    }
    catch(e) {
        return value.toFixed(format.decimals||0) + " " + format.currencyCode;
    }
}


/**
 * Automatic creation of the first-level property as an object, used for FNP and FNC below
 * example:
 * const test = FN.autoProp({});
 * test.User.name = "John"; // property User create automatic
 * test.User.age = 42; // property age added to test.User
 * console.log(test.data.items) // undefined, created property data
 **/
FN.autoProp = obj => new Proxy({}, { get: (proxy, prop) => {
    if(obj[prop] === undefined) {
        obj[prop] = {};
        proxy[prop] = new Proxy(proxy, {
            set: (_, prop2, val2) => (obj[prop][prop2] = val2, true),
            get: (_, prop2) => obj[prop][prop2]
        });
    }
    return obj[prop];
}});

/**
 * Functions for presenters, e.g. FNP.Order.shippingPrice = function(link) ...
 */
const FNP = FN.autoProp({});

/**
 * Functions for components, e.g. FNC.Banners.popupOverlay = function() ...
 */
const FNC = FN.autoProp({});

/**
 * Abbreviation for document.getElementById(name)
 * document.getElementById("name") -> ID.name
 * document.getElementById("name-hyphen") -> ID["name-hyphen"]
 */
const ID = new Proxy({}, { get: (_, prop) => document.getElementById(prop) });
